import Select from 'react-select';
import styled from "styled-components";
import { BorderProps, StyledLocationAreaProps, StyledReactSelectProps } from './LocationFields.types';



const getBorderStyle = (border?: BorderProps): string => {
  const defaultBorder = {
    width: "1px",
    style: "solid",
    color: "rgb(4, 4, 4)"
  };

  if (!border) {
    return "none";
  }

  const width = border.borderWidth || defaultBorder.width;
  const style = border.borderStyle || defaultBorder.style;
  const color = border.borderColor || defaultBorder.color;

  return `${width} ${style} ${color}`;
};

export const LocationArea = styled.div<StyledLocationAreaProps>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border: ${({ border }) => getBorderStyle(border)};
  border-radius: 0.75rem;
  padding: 1rem;
`;

export const LocationFormRow = styled.div`
  display: flex;
  margin-bottom: 0.625rem;
  gap: 0.5rem;
  width: 100%;
  flex-wrap: wrap;
  

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 5rem;
  }
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
`;

export const FieldTitle = styled.div`
  margin-bottom: 0.4375rem;
  margin-top: 0.4375rem;
  font-size: 0.875rem;
  font-weight: 400;
`;

export const LocationInput = styled.input`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: 2.375rem;
  border: 0.0625rem solid #878787;
  border-radius: 0.3125rem;
  color: #000000;
  font-size: 1rem;
  font-weight: 400;
  text-align: left;
  padding: 0.625rem;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #fe2f67;
  }
`;

export const LocationDropdown = styled.select<StyledLocationAreaProps>`
  border: ${({ border }) => getBorderStyle(border)};
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: 2.375rem;
  border-radius: 0.3125rem;
  padding: 0.625rem;
  font-size: 0.875rem;
  box-sizing: border-box;

  @media (max-width: 600px) {
    min-width: 0;
    font-size: 1rem;
  }

  &:focus {
    border-color: #fe2f67;
    outline: none;
  }

  option {
    padding: 0.625rem;
    font-family: "Arial", sans-serif;
    text-align: left;
  }
`;

export const RequiredAsterisk = styled.span`
  color: #fe2f67;
`;

export const StyledReactSelect = styled(Select)<StyledReactSelectProps>`
  .react-select__control {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: 2.375rem;
    border: ${({ border }) => getBorderStyle(border)};
    border-radius: 0.3125rem;
    padding: 0.125rem 0.625rem;
    font-size: 0.875rem;
    box-sizing: border-box;
    background: white;
    box-shadow: none;
    &:hover {
      border-color: #fe2f67;
    }
  }
  .react-select__control--is-focused {
    border-color: #fe2f67;
    box-shadow: none;
  }
  .react-select__indicators {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.1rem;
    margin-right: 0.2rem;
  }
  .react-select__clear-indicator {
    color: #fe2f67;
    order: 2;
    margin-left: 0;
    margin-right: 0;
    padding: 0 0.1rem;
  }
  .react-select__dropdown-indicator {
    color: #878787;
    order: 3;
    margin-left: 0;
    padding: 0 0.1rem;
  }
  .react-select__indicator-separator {
    display: none;
  }
  .react-select__value-container {
    padding: 0;
  }
  .react-select__input-container {
    margin: 0;
    padding: 0;
  }
  .react-select__single-value {
    color: #000;
    font-size: 1rem;
  }
  .react-select__menu {
    z-index: 10;
  }
  .react-select__option {
    font-family: "Arial", sans-serif;
    text-align: left;
    padding: 0.625rem;
    font-size: 0.875rem;
  }
  .react-select__option--is-focused {
    background: #ffe3ed;
    color: #fe2f67;
  }
  .react-select__option--is-selected {
    background: #fe2f67;
    color: #fff;
  }
  .react-select__placeholder {
    color: #878787;
    font-size: 0.875rem;
  }
`;